/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ended_TextInputs */

const en_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ended`)
};

const ar_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منتهي`)
};

const de_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendet`)
};

const es_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizado`)
};

const fr_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const it_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminato`)
};

const ja_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

const ko_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`종료됨`)
};

const pt_br_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrado`)
};

const ru_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершено`)
};

const th_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ้นสุดแล้ว`)
};

const tr_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sona Erdi`)
};

const zh_cn_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已结束`)
};

const zh_tw_ended_text = /** @type {(inputs: Ended_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已結束`)
};

/**
* | output |
* | --- |
* | "Ended" |
*
* @param {Ended_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const ended_text = /** @type {((inputs?: Ended_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ended_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ended_text(inputs)
	if (locale === "ar") return ar_ended_text(inputs)
	if (locale === "de") return de_ended_text(inputs)
	if (locale === "es") return es_ended_text(inputs)
	if (locale === "fr") return fr_ended_text(inputs)
	if (locale === "it") return it_ended_text(inputs)
	if (locale === "ja") return ja_ended_text(inputs)
	if (locale === "ko") return ko_ended_text(inputs)
	if (locale === "pt_br") return pt_br_ended_text(inputs)
	if (locale === "ru") return ru_ended_text(inputs)
	if (locale === "th") return th_ended_text(inputs)
	if (locale === "tr") return tr_ended_text(inputs)
	if (locale === "zh_cn") return zh_cn_ended_text(inputs)
	return zh_tw_ended_text(inputs)
});